"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _RadioButton = require("./RadioButton.styles");

var _elements = require("../../../styles/elements");

var _RadioButtons = require("../RadioButtons.provider");

/* eslint-disable jsx-a11y/label-has-associated-control */
var RadioButton = function RadioButton(_ref) {
  var className = _ref.className,
      id = _ref.id,
      value = _ref.value,
      children = _ref.children;

  var _useContext = (0, _react.useContext)(_RadioButtons.RadioButtonsContext),
      onChange = _useContext.onChange,
      name = _useContext.name,
      selectedValue = _useContext.value,
      type = _useContext.type;

  var inputId = id || value;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)("input", {
      type: "radio",
      className: "grui hidden",
      css: [_elements.input.styles.preflight, _RadioButton.styles[type], process.env.NODE_ENV === "production" ? "" : ";label:RadioButton;"],
      id: inputId,
      value: value,
      name: name,
      checked: selectedValue === value,
      onChange: onChange
    }), (0, _jsxRuntime.jsx)("label", {
      htmlFor: inputId,
      css: [_elements.text.styles.textXs, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:RadioButton;"],
      className: (0, _clsx["default"])(className, 'grui inline-flex items-center justify-center px-10 cursor-pointer'),
      children: children
    })]
  });
};

RadioButton.propTypes = {
  className: _propTypes.string,

  /**
   * Unique id for associating label with input,
   * will use value for it if id isn't provided
   */
  id: _propTypes.string,

  /**
   * Radio input value
   */
  value: _propTypes.string.isRequired,

  /**
   * Label content
   */
  children: _propTypes.node
};
RadioButton.defaultProps = {
  className: undefined,
  id: undefined,
  children: undefined
};
var _default = RadioButton;
exports["default"] = _default;
//# sourceMappingURL=RadioButton.js.map